import { createUseStyles } from "react-jss";
import { alpha } from "../../theme/Mixins";

const cornerSize = 5;
const cornerWidth = 2;
const borderRadiuses = {
    squared: 0,
    soft: 15,
    rounded: 50,
};

const makeCornerStyle = () => ({
    position: "absolute",
    pointerEvents: "none",
    width: `${cornerSize}%`,
    margin: ({ theme }) =>
        Math.min(theme.BorderRadius, borderRadiuses.rounded) >= borderRadiuses.rounded ? 20 : 12,
    height: ({ ratio }) => `${cornerSize * ratio}%`,
});

export default createUseStyles({
    container: {
        display: "inline-block",
        background: ({ theme }) => alpha(theme.InputBackground, theme.ControlAlpha),
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 50),
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
    },
    signatureArea: {
        position: "relative",
    },
    canvas: {
        cursor: "crosshair",
    },
    image: {
        width: ({ signatureWidth }) => `${signatureWidth}px`,
        height: ({ signatureWidth, ratio }) => `${signatureWidth / ratio}px`,
        cursor: "not-allowed",
    },
    undoButton: {
        position: "absolute",
        top: "20%",
        left: "10%",
        marginBottom: ({ signatureWidth }) => `${signatureWidth * 0.03}px`,
        cursor: "pointer",
    },
    clearButton: {
        position: "absolute",
        top: "20%",
        right: "10%",
        marginBottom: ({ signatureWidth }) => `${signatureWidth * 0.03}px`,
        cursor: "pointer",
    },
    signatureLine: {
        position: "absolute",
        bottom: "20%",
        left: "10%",
        right: "10%",
        pointerEvents: "none",
        fontSize: ({ signatureWidth }) => signatureWidth * 0.04,
        lineHeight: ({ signatureWidth }) => `${signatureWidth * 0.1}px`,
        borderBottom: "2px solid #999",
    },
    topLeftCorner: {
        ...makeCornerStyle(),
        top: 0,
        left: 0,
        borderTop: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
        borderLeft: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
    },
    topRightCorner: {
        ...makeCornerStyle(),
        top: 0,
        right: 0,
        borderTop: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
        borderRight: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
    },
    bottomLeftCorner: {
        ...makeCornerStyle(),
        bottom: 0,
        left: 0,
        borderBottom: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
        borderLeft: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
    },
    bottomRightCorner: {
        ...makeCornerStyle(),
        bottom: 0,
        right: 0,
        borderBottom: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
        borderRight: ({ theme }) => `${cornerWidth}px solid ${theme.ControlBorderColor}`,
    },
});
